export const CHART_TONE_TOKEN = {
    'chart-1': '--color-chart-1',
    'chart-2': '--color-chart-2',
    'chart-3': '--color-chart-3',
    'chart-4': '--color-chart-4',
    'chart-5': '--color-chart-5',
    'chart-6': '--color-chart-6',
    brand: '--color-brand-bg',
    success: '--color-state-success-solid',
    warning: '--color-state-warning-solid',
    danger: '--color-state-danger-solid',
    info: '--color-state-info-solid',
    neutral: '--color-state-neutral-solid',
};
const CATEGORICAL = [
    'chart-1',
    'chart-2',
    'chart-3',
    'chart-4',
    'chart-5',
    'chart-6',
];
/**
 * CSS-цвет ряда. Цвет следует за сущностью, а не за местом: передавайте
 * `tone`/`colorToken` явно, если набор рядов меняется фильтром. Дальше шестого
 * ряда без явного цвета — серый, а не повтор палитры по кругу (повтор выдал бы
 * два разных ряда за один).
 */
export function seriesColor(series, index) {
    if (series.colorToken)
        return `var(${series.colorToken})`;
    const tone = series.tone ?? CATEGORICAL[index] ?? 'neutral';
    return `var(${CHART_TONE_TOKEN[tone]})`;
}
//# sourceMappingURL=types.js.map